import { render, staticRenderFns } from "./CrmBoardApi.vue?vue&type=template&id=3956037c&lang=pug&"
import script from "./CrmBoardApi.vue?vue&type=script&lang=js&"
export * from "./CrmBoardApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports